import { gql } from '@apollo/client';

export const QUERY_USER_HOME = gql`
  query GetUserOnHome {
    getUserOnHome {
      id
      firstname
      lastname
      email
      role
      tel
      username
      isPairTeacher
      ong
      options {
        notifications
      }
      avatar {
        id
        name
        media {
          url
        }
      }
      classe {
        id
        debut
        fin
        lycee
        name
        operationid
      }
    }
  }
`;
